import { Box, Collapse, Paper, Stack, Typography } from "@mui/material";
import { useState } from "react";
import ExpandCollapseButton from "@entrilia/shared/components/ExpandCollapseButton";
import CollapseIcon from "@entrilia/shared/icons/CollapseIcon";
import ExpandIcon from "@entrilia/shared/icons/ExpandIcon";
import type { MembersChangeRequestView } from "../../../../../api/types/membersChangeRequestTypes";
import { CHANGES_WAITING_FOR_APPROVAL_MESSAGE } from "../../common/PendingChangesAlert";
import MemberChangeRequestDetails from "./MemberChangeRequestDetails";

interface Props {
  mergedChangeRequest: MembersChangeRequestView;
  pendingChangeRequest: MembersChangeRequestView;
}

const FinalRequestSection = ({ mergedChangeRequest, pendingChangeRequest }: Props) => {
  const [expanded, setExpanded] = useState(false);
  const toggleExpanded = () => setExpanded((current) => !current);

  return (
    <Paper variant="outlined">
      <Stack direction="row" spacing={1} sx={{ py: 1, px: 2, cursor: "pointer" }} onClick={toggleExpanded}>
        <ExpandCollapseButton
          expanded={expanded}
          onToggle={toggleExpanded}
          ExpandIcon={ExpandIcon}
          CollapseIcon={CollapseIcon}
          aria-label={expanded ? "Collapse the final request" : "Expand the final request"}
        />
        <Stack spacing={0.5}>
          <Typography variant="subtitle1">Final request (#{pendingChangeRequest.referenceCode})</Typography>
          <Typography color="textSecondary">{CHANGES_WAITING_FOR_APPROVAL_MESSAGE}</Typography>
        </Stack>
      </Stack>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Box sx={{ p: 2 }}>
          <MemberChangeRequestDetails changeRequest={mergedChangeRequest} />
        </Box>
      </Collapse>
    </Paper>
  );
};

export default FinalRequestSection;
